import React from 'react';
import { useSurveyContext } from '../contexts/SurveyContext';
import { getPrimaryColor } from '../utils/surveyHelpers';

export const NavigationButtons = () => {
  const {
    survey,
    hasPrev,
    hasNext,
    isAnswered,
    currentQuestion,
    goBack,
    goForward
  } = useSurveyContext();

  const primaryColor = getPrimaryColor(survey);
  const isCommentQuestion = currentQuestion?.q_type === 'comment';
  const showNoComment = !isAnswered && isCommentQuestion;

  return (
    <div className="buttons">
      {hasPrev ? (
        <div className="prev-button" onClick={goBack}>
          <span className="nav-chevron">&#8249;</span> Back
        </div>
      ) : (
        <div />
      )}
      {showNoComment ? (
        <div
          className="next-button active"
          style={{ backgroundColor: primaryColor }}
          onClick={goForward}
        >
          No Comment
        </div>
      ) : (
        <div
          className={`next-button ${isAnswered ? 'active' : ''}`}
          style={isAnswered ? { backgroundColor: primaryColor } : {}}
          onClick={goForward}
        >
          {hasNext ? 'Next' : 'Finish'} <span className="nav-chevron">&#8250;</span>
        </div>
      )}
    </div>
  );
};